import { derived } from "svelte/store";
import { getDistance } from "geolib";
import journey from "../journey.js";
import chronology from "../chronology.js";

export function distanceIntervaled(minimumInterval, update, stores = []) {
	let lastUpdateAt;

	return derived([journey, ...stores], (stores, set) => {
		const [$journey] = stores;

		if (!$journey || !$journey.location) {
			return;
		}

		const shouldUpdate =
			lastUpdateAt === undefined ||
			!lastUpdateAt ||
			getDistance($journey.location, lastUpdateAt) > minimumInterval;

		if (shouldUpdate) {
			lastUpdateAt = $journey.location;
			update(stores, set);
		}
	});
}

export function timeIntervaled(minimumInterval, update, stores = []) {
	let lastUpdateAt;

	return derived([chronology, ...stores], (stores, set) => {
		const [$chronology] = stores;

		const shouldUpdate =
			$chronology &&
			$chronology.duration &&
			(lastUpdateAt === undefined || $chronology.duration - lastUpdateAt > minimumInterval);

		if (shouldUpdate) {
			lastUpdateAt = $chronology && $chronology.duration;
			update(stores, set);
		}
	});
}
